import React from "react"
import FieldContainer from "components/Form/FormFields/FieldParts/FieldContainer"
import Label from "components/Form/FormFields/FieldParts/Label"
import InputFeedback from "components/Form/FormFields/FieldParts/InputFeedback"
import glamorous from "glamorous"
import style from "utils/style"

const InlineInputWrapper = props => (
  <FieldContainer>
    <InlineContainer inline={props.inline}>
      <Label htmlFor={props.id} {...props}>
        {props.label}
      </Label>
      <ColumnWrapper inline={props.inlineChildren}>
        {props.children}
      </ColumnWrapper>
    </InlineContainer>
    <InputFeedback {...props} />
  </FieldContainer>
)

export default InlineInputWrapper

const InlineContainer = glamorous.div(
  {
    display: "flex",
    width: "100%",
    alignItems: "flex-start",
    [style.size.mobile]: {
      flexDirection: "column",
    },
  },
  ({ inline }) => ({
    flexDirection: inline ? "row" : "column",
  })
)

const ColumnWrapper = glamorous.div({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
})



// WEBPACK FOOTER //
// ./src/components/Form/FormFields/InlineInputWrapper/index.js